import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {FluidReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

interface FluidReplacementAfterMonthsInputProps {
  name: FluidReplacementServiceIntervals;
}

/**
 * Numeric input component for defining the time interval (in months) after which a vehicle fluid should be replaced.
 * Used in service interval tracking to set the replacement frequency based on time.
 * Automatically calculates the next replacement date when changed.
 *
 * @param props.name - The fluid name (e.g., 'brakeFluid', 'coolantFluid')
 */
export function FluidReplacementAfterMonthsInput(props: FluidReplacementAfterMonthsInputProps) {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.FLUID_REPLACEMENT_MONTHS_CHANGED,
      name: props.name,
      value,
    });
  };

  return (
    <Field
      type="number"
      name={`serviceIntervals.${props.name}.nextReplacementMileage`}
      label={i18n.t('entity.vehicle.labels.replacementAfterMonths')}
      suffix={i18n.t('general.metric.months')}
      onChange={handleChange}
    />
  );
}
